<script>
  export default {
    props: {
      targetTime: {
        required: false
      },
      withHours: {
        type: Boolean,
        default: true,
        required: false
      }
    },
    data() {
      return {
        remainingTime: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        intervalId: null,
        timeTo: null
      }
    },
    created() {
      this.prepareTimer();
      this.startTimer();
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
    methods: {
      startTimer() {
        this.intervalId = setInterval(() => {
          let now = Math.floor(Date.now() / 1000);
          const timeDiff = this.timeTo - now;
          if (timeDiff <= 0) {
            clearInterval(this.intervalId);
            this.remainingTime = 0;
          } else {
            this.remainingTime = timeDiff;
          }
          this.hours = Math.floor((this.remainingTime / 60 / 60));
          this.minutes = Math.floor((this.remainingTime / 60) % 60);
          let seconds = Math.floor(this.remainingTime % 60);
          this.seconds = seconds < 10 ? '0' + seconds : seconds;
        }, 1000);
      },
      prepareTimer() {
        if (!this.targetTime) {
          return;
        }
        if (typeof this.targetTime === 'string') {
          this.timeTo = (new Date(this.targetTime).getTime()) / 1000;
        }else {
          this.timeTo = this.targetTime;
        }
      }
    },
    watch: {
      targetTime() {
        clearInterval(this.intervalId);
        this.prepareTimer();
        this.startTimer();
      }
    },
    template: '<div class="timer-watch" v-if="minutes != 0 || hours != 0 || seconds != 0"><span v-if="withHours">{{ hours }}:</span> <div class="timer"><div>{{ minutes }}:{{ seconds }}</div></div></div>'
  }
</script>
